export const updateCareerMutation = `mutation updatecareer(
              $careerid: Int!, $mediaitemid: Int, $name: String, $courseIds: [Int], $active: Boolean, $positionCourseIds: [CourseAndPosition]
            ){
              UpdateCareer(inputUpdateCareer: {
                careerId: $careerid,
                mediaItemId: $mediaitemid,
                name: $name,
                courseIds: $courseIds,
                active: $active,
                positionCourseIds: $positionCourseIds
              }){
                career{
                  id
                  name
                  slug
                  active
                  position
                  workspaceId
                  dateCreated
                  relatedMedia{
                    mediaitemid
                  }
                }
              }
            }`;
